// Google Maps configuration
// This file ensures all components use the same configuration to prevent loader conflicts

// All libraries needed across the application
// Combined from LiveMap, GeofenceDrawer, and GeofenceDebugDrawer requirements
export const GOOGLE_MAPS_LIBRARIES: ("places" | "geocoding" | "marker" | "maps")[] = [
  'places',
  'geocoding',
  'marker',
];

// Consistent loader ID across all components
export const GOOGLE_MAPS_LOADER_ID = 'google-map-script';

// Stable options object - created once at module load time
// This prevents infinite re-render loops when useJsApiLoader sees a new object reference
const GOOGLE_MAPS_OPTIONS = {
  id: GOOGLE_MAPS_LOADER_ID,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  libraries: GOOGLE_MAPS_LIBRARIES,
};

// Google Maps loader options - returns stable reference
export const getGoogleMapsLoaderOptions = () => GOOGLE_MAPS_OPTIONS;
